import {
    ApplicationConfig,
    importProvidersFrom,
    provideZoneChangeDetection,
} from '@angular/core';
import { provideRouter, Route } from '@angular/router';
import { BrowserModule } from '@angular/platform-browser';
import {
    provideHttpClient,
    withInterceptorsFromDi,
    HTTP_INTERCEPTORS,
    withFetch,
} from '@angular/common/http';

import {
    IPublicClientApplication,
    PublicClientApplication,
    InteractionType,
    BrowserCacheLocation,
    LogLevel,
} from '@azure/msal-browser';

import {
    MsalInterceptor,
    MSAL_INSTANCE,
    MsalInterceptorConfiguration,
    MsalGuardConfiguration,
    MSAL_GUARD_CONFIG,
    MSAL_INTERCEPTOR_CONFIG,
    MsalService,
    MsalGuard,
    MsalBroadcastService,
} from '@azure/msal-angular';

import { AuthConfig, IAuthConfig, HttpInterceptorService } from './data-access';

function loggerCallback(logLevel: LogLevel, message: string) {
    if (logLevel > LogLevel.Error) return;
    console.log(message);
}

function MSALInstanceFactory(): IPublicClientApplication {
    const authConfig = AuthConfig.config;
    const x: IPublicClientApplication = new PublicClientApplication({
        auth: {
            clientId: authConfig.clientId,
            authority: authConfig.authority,
            knownAuthorities: authConfig.knownAuthorities,
            redirectUri: '/',
            postLogoutRedirectUri: '/',
        },
        cache: {
            cacheLocation: BrowserCacheLocation.LocalStorage,
        },
        system: {
            allowNativeBroker: false, // Disables WAM Broker
            loggerOptions: {
                loggerCallback,
                logLevel: LogLevel.Info,
                piiLoggingEnabled: false,
            },
        },
    });
    return x;
}

function MSALInterceptorConfigFactory(): MsalInterceptorConfiguration {
    const authConfig = AuthConfig.config;
    const protectedResourceMap = new Map<string, Array<string>>();
    protectedResourceMap.set(authConfig.uri, authConfig.scopes);

    return {
        interactionType: InteractionType.Redirect,
        protectedResourceMap,
    };
}

function MSALGuardConfigFactory(): MsalGuardConfiguration {
    return {
        interactionType: InteractionType.Popup,
        authRequest: {
            scopes: [...AuthConfig.config.scopes],
        },
        loginFailedRoute: '/login-failed',
    };
}

export class DataAccessAppConfig {

    private static _providers = [
        provideZoneChangeDetection({ eventCoalescing: true }),
        importProvidersFrom(BrowserModule),
        provideHttpClient(withInterceptorsFromDi(), withFetch()),
        {
            provide: HTTP_INTERCEPTORS,
            useClass: HttpInterceptorService,
            multi: true,
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: MsalInterceptor,
            multi: true,
        },
        {
            provide: MSAL_INSTANCE,
            useFactory: MSALInstanceFactory,
        },
        {
            provide: MSAL_GUARD_CONFIG,
            useFactory: MSALGuardConfigFactory,
        },
        {
            provide: MSAL_INTERCEPTOR_CONFIG,
            useFactory: MSALInterceptorConfigFactory,
        },
        MsalService,
        MsalGuard,
        MsalBroadcastService,
    ];

    static getApplicationConfig(appRoutes: Route[]): ApplicationConfig {
        return {
            providers: [provideRouter(appRoutes), ...this._providers]
        };
    }

}
